import { Component } from '@angular/core';
/**
 * Componente per una rotta di caricamento
 *
 * @export
 * @class WhitePageComponent
 */

@Component({
    selector: 'app-white-page-component',
    templateUrl: './white-page.component.html',
    styleUrls: ['./white-page.component.scss'],
    standalone: false
})
export class WhitePageComponent {}
